<template>
    <div class="blog-sidebar-item">
        <h1 class="heading-border-bottom-anim" v-if="title">{{title}}</h1>
        <ul class="blog-sidebar-tags" v-if="lists">
            <li v-for="(list, i) in lists" :key="i">
                <router-link :to="list.url">{{list.title}}</router-link>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    name: 'BlogTags',
    props: {
        title: {
            type: String,
            default: 'Tags'
        },
        lists: {
            type: Array,
            default: () => {}
        }
    },
}
</script>